<script setup lang="ts">
import {
  PriceCalendar,
  PriceCalendarTileType,
} from '@apps/main/new-desktop/modules/calendars';

import type {
  PeekPriceModalCalendar,
  PeekPriceModalItineraryData,
} from '../models';

import PeekPriceModalItinerary from './PeekPriceModalItinerary.vue';
import PeekPriceModalDesktopLayout from './PeekPriceModalDesktopLayout.vue';

interface PeekPriceModalDesktopProps {
  itinerary: PeekPriceModalItineraryData;
  calendar: PeekPriceModalCalendar;
}

const props = defineProps<PeekPriceModalDesktopProps>();

interface PeekPriceModalDesktopEmits {
  (eventName: 'cancel'): void;
  (eventName: 'confirm'): void;
  (eventName: 'select-date', date: Date): void;
  (eventName: 'select-month', date: Date): void;
}

const emit = defineEmits<PeekPriceModalDesktopEmits>();
</script>

<template>
  <PeekPriceModalDesktopLayout
    :itinerary="props.itinerary"
    @confirm="emit('confirm')"
    @cancel="emit('cancel')"
  >
    <template #itinerary>
      <PeekPriceModalItinerary :itinerary="props.itinerary" />
    </template>
    <template #priceCalendar>
      <PriceCalendar
        :selected-month="props.calendar.selectedMonth"
        :months="props.calendar.months"
        :price-calendar-state="props.calendar.priceCalendarState"
        :allow-selection-for="[
          PriceCalendarTileType.CurrentMonthAvailableDay,
          PriceCalendarTileType.CurrentMonthUnsearchedDay,
        ]"
        header-font="font-label-xl-light"
        @select-month="emit('select-month', $event)"
        @select-date="emit('select-date', $event)"
      />
    </template>
  </PeekPriceModalDesktopLayout>
</template>
